import t from "./extends3.mjs";
import * as P from "react";
import { useUtils as T, useDefaultDates as d } from "./useUtils.mjs";
import { applyDefaultViewProps as D } from "./views.mjs";
import { applyDefaultDate as p } from "./date-utils.mjs";
import { DatePickerToolbar as b } from "./DatePickerToolbar.mjs";
import { uncapitalizeObjectKeys as x } from "./slots-migration.mjs";
import h from "./useThemeProps.mjs";
function z(u, n) {
  var o, l, a, s;
  const r = T(), i = d(), e = h({
    props: u,
    name: n
  }), c = P.useMemo(() => {
    var m;
    return ((m = e.localeText) == null ? void 0 : m.toolbarTitle) == null ? e.localeText : t({}, e.localeText, {
      datePickerToolbarTitle: e.localeText.toolbarTitle
    });
  }, [e.localeText]), f = (o = e.slots) != null ? o : x(e.components);
  return t({}, e, {
    localeText: c
  }, D({
    views: e.views,
    openTo: e.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    disableFuture: (l = e.disableFuture) != null ? l : !1,
    disablePast: (a = e.disablePast) != null ? a : !1,
    minDate: p(r, e.minDate, i.minDate),
    maxDate: p(r, e.maxDate, i.maxDate),
    slots: t({
      toolbar: b
    }, f),
    slotProps: (s = e.slotProps) != null ? s : e.componentsProps
  });
}
export {
  z as useDatePickerDefaultizedProps
};
//# sourceMappingURL=shared.mjs.map
